<template>
  <div class="relative" ref="containerRef">
    <button
      @click="open = !open"
      class="flex items-center gap-2 h-9 px-3 border border-slate-300 rounded-lg text-sm bg-white hover:bg-slate-50 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-header transition-colors shadow-sm"
    >
      <span>{{ label }}</span>
      <span v-if="selectedCount > 0 && selectedCount < developments.length" class="bg-header text-white text-xs rounded-full px-1.5 py-0.5">
        {{ selectedCount }}
      </span>
      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div
      v-if="open"
      class="absolute left-0 mt-1 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto text-gray-800"
    >
      <div class="p-2 border-b border-gray-100 flex items-center justify-between gap-2">
        <span class="text-xs text-gray-500 font-medium">Developments</span>
        <button @click="selectAll" class="text-xs text-header hover:underline whitespace-nowrap">All</button>
        <button @click="clearAll" class="text-xs text-gray-400 hover:underline whitespace-nowrap">None</button>
      </div>
      <ul class="py-1">
        <li
          v-for="dev in developments"
          :key="dev"
          class="flex items-center gap-2 px-3 py-1.5 hover:bg-gray-50 cursor-pointer text-gray-800"
          @click="toggle(dev)"
        >
          <input
            type="checkbox"
            :checked="isSelected(dev)"
            class="w-4 h-4 accent-header cursor-pointer"
            @click.stop="toggle(dev)"
          />
          <span class="text-sm text-gray-800">{{ dev }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  developments: { type: Array, default: () => [] },
  selectedDevelopments: { type: Set, default: () => new Set() }
})

const emit = defineEmits(['update:selectedDevelopments'])

const open = ref(false)
const containerRef = ref(null)

const selectedCount = computed(() => props.selectedDevelopments.size)

const label = computed(() => {
  if (selectedCount.value === 0 || selectedCount.value === props.developments.length) {
    return 'All Developments'
  }
  if (selectedCount.value === 1) {
    return [...props.selectedDevelopments][0]
  }
  return `${selectedCount.value} Developments`
})

const isSelected = (dev) => props.selectedDevelopments.has(dev)

const toggle = (dev) => {
  const updated = new Set(props.selectedDevelopments)
  if (updated.has(dev)) {
    updated.delete(dev)
  } else {
    updated.add(dev)
  }
  emit('update:selectedDevelopments', updated)
}

const selectAll = () => emit('update:selectedDevelopments', new Set(props.developments))
const clearAll = () => emit('update:selectedDevelopments', new Set())

const handleClickOutside = (e) => {
  if (containerRef.value && !containerRef.value.contains(e.target)) {
    open.value = false
  }
}

onMounted(() => document.addEventListener('mousedown', handleClickOutside))
onUnmounted(() => document.removeEventListener('mousedown', handleClickOutside))
</script>
